import React from 'react'
import { connect } from 'react-redux'
import MenuItem from '../common/MenuItem'
import authSelector from '../../selectors/authSelector'
import profileSelector from '../../selectors/profileSelector'
import ProductsItems from '../common/SidebarMenu/ProductsItems'
import EventsItems from '../common/SidebarMenu/EventsItems'

const studentMenuItems = [
  // { label: 'داشبورد', iconClass: 'fa fa-th-large', url: '/dashboard' },
  // { label: 'محصولات من', iconClass: 'fa fa-book', url: '/dashboard/products' },
  // {
  //   label: 'آزمون آنلاین',
  //   iconClass: 'fa fa-pencil-square-o',
  //   url: '/dashboard/online-tests'
  // },
  // { label: 'رویداد‌ها', iconClass: 'fa fa-calendar', url: '/dashboard/events' },
  // { label: 'رویداد‌های من', iconClass: 'fa fa-calendar', url: '/dashboard/events/my-events' },
  // {
  //   label: 'گواهی‌ها',
  //   iconClass: 'fa fa-certificate',
  //   url: '/dashboard/certificates',
  // },
  // { label: 'نرم افزار‌ها', iconClass: 'fa fa-laptop', url: '/dashboard/apps' },
  {
    label: 'بسته‌های تخفیفی',
    iconClass: 'fa fa-star',
    url: '/v/list/?type=package',
    isExternal: true,
  },
  { label: 'اعتبار', iconClass: 'fa fa-credit-card', url: '/dashboard/credit' },
  { label: 'کمد جوایز', iconClass: 'fa fa-gift', url: '/dashboard' },
  {
    label: 'سفارش‌ها',
    iconClass: 'fa fa-shopping-cart',
    url: '/dashboard/orders',
    withPendingOrderCount: true,
  },
]

const StudentMenuItems = ({ userProfile: { pending_orders }, isSideBarOpen, userType }) => (
  <div>
    <ProductsItems isSidebarOpen={isSideBarOpen} />
    <EventsItems isSidebarOpen={isSideBarOpen} userType={userType} />
    <div className="vertical-menu">
      {studentMenuItems.map(menuItem => (
        <MenuItem {...menuItem} key={menuItem.url} pendingOrders={pending_orders} />
      ))}
    </div>
  </div>
)

const mapStateToProps = state => ({
  ...authSelector(state),
  ...profileSelector(state),
  isSideBarOpen: state.sidebar.isOpen,
})

export default connect(mapStateToProps)(StudentMenuItems)



// WEBPACK FOOTER //
// ./src/components/student/StudentMenuItems.js